import React from 'react';

import ListResource from './ListResource.jsx';

const api = '/api/core/showrooms';

const ListShowrooms = () => (
  <ListResource
    {...{
      searchable: true,
      api,
      sort: { orgId: 1 },
      actions: {
        fileImport: true,
        fileExport: true,
      },
      cols: [
        { key: 'orgId', sortable: true, children: 'Organization ID' },
        { key: 'name', sortable: true, children: 'Company Name' },
        { key: 'showroom', sortable: true, children: 'Showroom Name' },
        { key: 'fax' },
        { key: 'tel' },
        { key: 'email' },
      ],
    }}
  />
);

export default ListShowrooms;
